// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import DealerHierarchyFacet from '../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import FacetsAccordion from './facets';
import LinkType from '@deere/cps-it.warranty-model-factory/lib/link';
import ReportLinks from '../../../shared/components/report-links';
import SearchBox from '../../../shared/components/search-box';
import SearchByDropDown from '../state/search-by-dropdown';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SpaAccordion from './special-allowance';
import TcsmSettings from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import UsefulLinksPanel from './useful-links-panel';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {hasAccess} from '../../../shared/services/security';
import {mapSearchPlaceHolder} from '../../../home-page/shared/services/home-page-helper';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function readSpaClaimsIfAuthorized() {

    if (this.state.showSpa) {

        this.props.actions.readSpaClaims(this.props.wipFacets.dealers, this.props.tcsmSettings.selectedSpaLevels);

    }

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

class TabmWip extends Component {

    state = {

        showSpa: hasAccess(this.context.security, 'TABM', 'TABM_SPL_ALLOWANCE_READ')
    };

    componentWillMount() {

        if (this.props.territories.length < 1 || this.props.wipFacets.dealers.length < 1) {

            this.props.actions.readTerritories(this.props.user.id, this.state);

        } else {

            this::readSpaClaimsIfAuthorized();
            this.props.actions.updateFilteredTerritories(this.props.territories);

        }

    }

    render() {

        return (
            <section className='tabm-wip'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='tabm-homepage-aside'>
                    <FacetsAccordion/>
                    <ReportLinks
                        accordion={this.props.reportsAccordion}
                        onAccordionToggle={this.props::handleAccordionToggle}
                        parentRoute='tabm'
                        routes={this.props.reportsRoutes}
                    />
                    <UsefulLinksPanel links={this.props.links}/>
                </aside>
                <main className='tabm-homepage-main'>
                    <SearchBox
                        defaultOption={this.props.searchByDropDown.selectedOption.key}
                        onOptionChange={this.props.actions.updateSearchByDropDown}
                        onQueryChange={this.props.actions.updateSearchQueryString}
                        onSearch={this.props::handleSearch}
                        placeholderText={mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                        queryString={this.props.searchQueryString}
                        searchBy={this.props.searchByDropDown.searchBy}
                    />
                    {this.state.showSpa && <SpaAccordion/>}
                </main>
            </section>
        );

    }

}

TabmWip.displayName = 'TabmWip';
TabmWip.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    links: PropTypes.arrayOf(PropTypes.instanceOf(LinkType)).isRequired,
    reportsAccordion: PropTypes.instanceOf(Accordion).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    tcsmSettings: PropTypes.instanceOf(TcsmSettings).isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    user: PropTypes.instanceOf(User).isRequired,
    wipFacets: PropTypes.instanceOf(DealerHierarchyFacet).isRequired
};
TabmWip.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default TabmWip;



// WEBPACK FOOTER //
// ./src/tabm/wip/components/index.js